import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http
    .postData("/asesmen-awal-keperawatan-intensif", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-awal-keperawatan-intensif/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-keperawatan-intensif`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-keperawatan-intensif/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-awal-keperawatan-intensif/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

async function verifyDpjp(id: number, data: { dpjp_user_id: number }) {
  const response = await http
    .postData(`/asesmen-awal-keperawatan-intensif/${id}/verify-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

async function verifyPpja(id: number, data: { ppja_user_id: number }) {
  const response = await http
    .postData(`/asesmen-awal-keperawatan-intensif/${id}/verify-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response;
}

function pdfUrl(id: number): string {
  return `${http.getAPI()}/asesmen-awal-keperawatan-intensif/${id}/pdf`;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verifyDpjp,
  verifyPpja,
  pdfUrl,
};
